import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function VendorOnboard() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [info, setInfo] = useState(null);
  const [invalid, setInvalid] = useState(false);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/vendor/onboard/${token}`).then((r) => setInfo(r.data)).catch(() => setInvalid(true));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pw !== pw2) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/vendor/onboard", { token, password: pw });
      setUser(data.user);
      toast.success("Welcome to KRVMart! Your vendor account is ready.");
      navigate("/vendor");
    } catch (e2) { toast.error(formatApiError(e2.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (invalid) return (
    <div className="mx-auto max-w-md px-4 py-24 text-center">
      <h1 className="text-2xl font-extrabold text-midnight">Invalid or expired link</h1>
      <p className="mt-2 text-muted-foreground">This onboarding link is no longer valid. Please contact KRVMart support.</p>
      <Link to="/contact" className="mt-6 inline-block rounded-full bg-midnight px-6 py-3 font-bold text-white">Contact Support</Link>
    </div>
  );
  if (!info) return <div className="py-32 text-center"><div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-gold border-t-transparent" /></div>;

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="rounded-3xl border border-border p-8">
        <Logo className="h-10 w-auto mb-6" />
        <span className="text-xs font-bold uppercase tracking-widest text-mart-wood">Vendor Onboarding</span>
        <h1 className="mt-1 text-2xl font-extrabold text-midnight">Welcome, {info.name}</h1>
        <p className="mt-1 text-sm text-muted-foreground">Set a password to activate your vendor account for <b>{info.email}</b>.</p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Create password" data-testid="onboard-password" className="w-full rounded-xl border border-border px-4 py-3 text-sm outline-none focus:border-gold" />
          <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Confirm password" data-testid="onboard-password2" className="w-full rounded-xl border border-border px-4 py-3 text-sm outline-none focus:border-gold" />
          <button disabled={busy} data-testid="onboard-submit" className="w-full rounded-full bg-midnight py-3.5 font-bold text-white disabled:opacity-60">{busy ? "Activating…" : "Activate My Vendor Account"}</button>
        </form>
      </div>
    </div>
  );
}
